import utils from 'utils'
import authenticationModalTemplate from '../common/authenticationModalList.html'
import certificationModalTemplate from '../common/certificationModalList.html'
import scanCodeLoginModalTemplate from '../common/scanCodeLoginModalTemplate.html'
class certificationListCtrl {
    constructor($rootScope, $scope, logger, httpRequest, $state, $stateParams, $uibModal, sweetalert) {
        $rootScope.$on('sms_logIn', function () {
            getAuthList()
        })
        $('body').addClass('leftnav-close')
        $scope.dictData = {}
        $scope.treeConfig = {
            width: '150%',
            isCheckall: true,
            concatParentChild: true,
            concatParentChildChecked: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.dictData.loginStatusArr = [
            {
                enumCode: '0',
                enumName: '未登录',
            },
            {
                enumCode: '1',
                enumName: '已登录',
            },
            {
                enumCode: '2',
                enumName: '关联公司登录',
            },
        ]
        $scope.dictData.identityAuthStatusArr = [
            {
                enumCode: '0',
                enumName: '未认证',
            },
            {
                enumCode: '1',
                enumName: '已认证',
            },
        ]
        const typecodeArr = ['tax_belong_region', 'identity_type', 'qpt_login_type', 'drawer_business_scope']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        httpRequest.post_getUserOrgEnableNameList().then((res) => {
            $scope.UserOrgList = res.data.value
        })
        $scope.search = {
            orgArr: [],
        }
        $scope.noReadMessage = 0
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
            },
        }
        // NOTE: 重置
        $scope.reset = () => {
            $scope.queryParam.param = {
                orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
            }
            getOrgList()
        }
        $scope.orgList = []
        function getOrgList() {
            httpRequest.get_getUserOrgList().then((res) => {
                $scope.orgList = res.data.value
                $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                    if (ele.orgId === $scope.userInfo.org.orgId) {
                        ele.checked = true
                    }
                })
            })
        }
        $scope.tabChange = function tabChange(v) {
            $scope.active = v
            getAuthList()
        }
        // 根据数据 判断页面tab页签展示
        $scope.active = 1
        let data = {
            orgIdList: [],
        }
        httpRequest.post_realNameAuthStatCount(data).then((res) => {
            if (res.data.value.notLogged === 0 && res.data.value.notAuthed > 0) {
                $scope.active = 2
            }
            $scope.tabChange($scope.active)
        })
        // NOTE: 搜索
        $scope.searchAuth = () => {
            getAuthList()
        }
        // NOTE: page修改
        $scope.pageChanged = (pageNum) => {
            getAuthList()
        }
        const getAuthList = () => {
            $scope.queryParam.param.orgIdList = $scope.queryParam.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            if ($scope.active === 2) {
                $scope.queryParam.param.businessScope = '0'
            }else{
                 $scope.queryParam.param.businessScope = ''
            }
            httpRequest.post_realNameAuthListPage($scope.queryParam).then((res) => {
                if (res && res.data && res.data.success) {
                    $scope.authList = res.data.value && res.data.value.list
                    $scope.authList.forEach((ele) => {
                        if (ele.ownBusinessScope && ele.ownBusinessScope.length) {
                            ele.businessScope = ele.ownBusinessScope
                                .map((item) => {
                                    return $scope.dictData.drawer_business_scope.filter((i) => {
                                        return i.enumCode === item
                                    })[0].enumName
                                })
                                .join('，')
                        }
                    })
                    $scope.total = res.data.value && res.data.value.total
                }
            })
            httpRequest.post_realNameAuthStatCount($scope.queryParam.param).then((res) => {
                if (res && res.data && res.data.success) {
                    $scope.orgCount = res.data.value.orgCount
                    $scope.drawerCount = res.data.value.drawerCount
                    $scope.notAuthed = res.data.value.notAuthed //开票员未认证数量
                    $scope.notLogged = res.data.value.notLogged //开票员未登录数量
                }
            })
        }
        getOrgList()
        getAuthList()
        $scope.modelShow = async function modelShow(item) {
            if (!item.authorizeId) return logger.logError('税局授权账户ID为空')
            let data = {
                authorizeId: item.authorizeId,
                force: false,
            }
            utils.loading('请求已发送...')
            let loginStatus = await httpRequest.post_getTokenIntercept(data).then(
                (res) => {
                    utils.loaded()
                    return res.data.value.loginStatus
                    //loginStatus 1登录成功  0未登录
                    // smsStatus
                },
                (err) => {
                    return 0
                }
            )
            // loginStatus = 0
            if (loginStatus) {
                getAuthList()
                $rootScope.$emit('certificationStatusChange')
                return logger.logSuccess('已登录')
            }
            /*  $uibModal
                .open({
                    template: authenticationModalTemplate,
                    controller: 'authenticationModalCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return {
                                authorizeId: item.authorizeId,
                            }
                        },
                    },
                })
                .result.then((data) => {
                getAuthList()
            })*/
        }
        $scope.modelRZ = function modelShow(item) {
            if (!item.authorizeId) return logger.logError('税局授权账户ID为空')
            $uibModal
                .open({
                    template: certificationModalTemplate,
                    controller: 'certificationModalCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return {
                                authorizeId: item.authorizeId,
                            }
                        },
                    },
                })
                .result.then((data) => {
                    $rootScope.$emit('certificationStatusChange')
                    if (data.code === 1) {
                        sweetalert.swal(
                            {
                                title: '重新登录',
                                text: data.mes,
                                type: 'success',
                                showCancelButton: true,
                                confirmButtonColor: '#0096e7',
                                confirmButtonText: '去登录',
                                cancelButtonText: '取消',
                                closeOnConfirm: true,
                                closeOnCancel: true,
                            },
                            (isConfirm) => {
                                if (isConfirm) {
                                    $scope.modelShow(item)
                                }
                            }
                        )
                    } else {
                        getAuthList()
                    }
                })
        }
        $scope.scanCodeLogin = function (item) {
            $uibModal
                .open({
                    template: scanCodeLoginModalTemplate,
                    controller: 'scanCodeLoginModalCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return {
                                authorizeId: item.authorizeId,
                            }
                        },
                    },
                })
                .result.then(
                    (data) => {
                        getAuthList()
                    },
                    (err) => {
                        getAuthList()
                    }
                )
        }
    }
}
certificationListCtrl.$inject = ['$rootScope', '$scope', 'logger', 'httpRequest', '$state', '$stateParams', '$uibModal', 'sweetalert']
export default certificationListCtrl



// WEBPACK FOOTER //
// ./src/app/main/certification/certificationListCtrl.js